import { PROJECT_TYPES } from '@/constants/content'

export interface ContactPayload {
    name: string
    company: string
    email: string
    phone: string
    projectType: string
    pourDate: string
    message: string
    privacy: boolean
    website: string
}

export type ContactField = 'name' | 'company' | 'email' | 'phone' | 'projectType' | 'pourDate' | 'message' | 'privacy'

export type ContactErrors = Partial<Record<ContactField, string>>

export const CONTACT_FIELD_ORDER: Array<ContactField> = [
    'name',
    'company',
    'email',
    'phone',
    'projectType',
    'pourDate',
    'message',
    'privacy'
]

export const CONTACT_LIMITS = {
    name: 120,
    company: 160,
    email: 254,
    phone: 40,
    pourDate: 80,
    message: 4000
}

export const EMPTY_CONTACT: ContactPayload = {
    name: '',
    company: '',
    email: '',
    phone: '',
    projectType: '',
    pourDate: '',
    message: '',
    privacy: false,
    website: ''
}

const CARRIAGE_RETURN = String.fromCharCode(13)
const EMAIL_PATTERN = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:"]{2,}$/
const PHONE_PATTERN = /^[+\d\s()\/.-]{5,40}$/

const readText = (source: Record<string, unknown>, key: string, max: number): string => {
    const value = source[key]

    if (typeof value !== 'string') return ''

    return value.split(CARRIAGE_RETURN).join('').trim().slice(0, max)
}

const readLine = (source: Record<string, unknown>, key: string, max: number): string => {
    return readText(source, key, max * 2).replace(/\s+/g, ' ').slice(0, max)
}

export const normalizeContact = (input: unknown): ContactPayload => {
    const source = (typeof input === 'object' && input !== null ? input : {}) as Record<string, unknown>

    return {
        name: readLine(source, 'name', CONTACT_LIMITS.name),
        company: readLine(source, 'company', CONTACT_LIMITS.company),
        email: readLine(source, 'email', CONTACT_LIMITS.email).toLowerCase(),
        phone: readLine(source, 'phone', CONTACT_LIMITS.phone),
        projectType: readLine(source, 'projectType', 80),
        pourDate: readLine(source, 'pourDate', CONTACT_LIMITS.pourDate),
        message: readText(source, 'message', CONTACT_LIMITS.message),
        privacy: source.privacy === true,
        website: readLine(source, 'website', 200)
    }
}

export const validateContact = (payload: ContactPayload): ContactErrors => {
    const errors: ContactErrors = {}

    if (payload.name.length < 2) errors.name = "Bitte geben Sie Ihren Namen an."
    if (!EMAIL_PATTERN.test(payload.email)) errors.email = "Bitte geben Sie eine gültige E-Mail-Adresse an."
    if (payload.phone && !PHONE_PATTERN.test(payload.phone)) errors.phone = "Bitte prüfen Sie die Telefonnummer."
    if (payload.projectType && !PROJECT_TYPES.includes(payload.projectType)) errors.projectType = "Bitte wählen Sie einen Eintrag aus der Liste."
    if (payload.message.length < 10) errors.message = "Bitte beschreiben Sie Ihr Vorhaben in ein paar Worten."
    if (!payload.privacy) errors.privacy = "Bitte bestätigen Sie, dass Sie die Datenschutzhinweise gelesen haben."

    return errors
}
